export default function FavoriteContact (contactId = -1) {
    this.contactId = contactId;
 }


// WEBPACK FOOTER //
// ./src/models/FavoriteContact.js